{
  "protocol": {
    "version": "1.0.0",
    "schemaUrl": "https://central.vsd.app.br/schemas/protocol/1.0.0/schema.json",
    "generatedAt": "2026-03-02T14:10:00-05:00"
  },
  "central": {
    "websocketUrl": "wss1://central.vsd.app.br",
    "websocketFallbackUrl": "wss2://central.vsd.app.br",
    "apiUrl": "https://api.central.vsd.app.br/v1",
    "apiFallbackUrl": "https://api2.central.vsd.app.br/v1"
  },
  "entity": {
    "id": "8f2ed7d0-c42f-4d9c-bd4c-df037e86c1a1",
    "name": "ABC Stores",
    "taxId": "85.499.746/0001-44",
    "status": "active"
  },
  "device": {
    "id": "9fd8b0fb-fca1-4b34-a7df-cc57d6f17da2",
    "serialNumber": "123456",
    "name": "ABC Kiosk 01",
    "status": "active"
  },
  "solution": {
    "id": "5f32b5a5-0940-4cb1-8f2c-2d3671db7fcb",
    "name": "VS Self Checkout",
    "version": "production",
    "status": "active",
    "license": {
      "id": "b2fd4d43-dc8f-4471-9f53-6a3b3554ca9f",
      "type": "subscription",
      "expiryDate": "2025-12-31T23:59:59-05:00",
      "warningPeriodDays": 30
    },
    "rollout": {
      "timezone": "America/Sao_Paulo",
      "downloadWindow": {
        "startDate": "2026-03-05",
        "endDate": "2026-03-08",
        "timeRanges": [
          {
            "startTime": "08:00",
            "endTime": "10:00"
          },
          {
            "startTime": "14:00",
            "endTime": "16:00"
          }
        ]
      },
      "installWindow": {
        "startDate": "2026-03-10",
        "endDate": "2026-03-12",
        "timeRanges": [
          {
            "startTime": "22:00",
            "endTime": "08:00"
          }
        ]
      },
      "defaults": {
        "retryPolicy": {
          "maxAttempts": 3,
          "backoffSeconds": 300
        }
      },
      "software": [
        {
          "id": "f9a6fbb7-2b62-4c8a-b35c-45ddf85e48e3",
          "name": "VS Self Checkout App",
          "version": "production",
          "category": "pwa",
          "url": "https://app.checkout.vsd.app.br",
          "isPrimaryApp": true,
          "status": "active",
          "settings": {},
          "updateType": "pwa",
          "strategy": {
            "type": "immediate"
          },
          "retryPolicy": {
            "maxAttempts": 2,
            "backoffSeconds": 60
          },
          "plan": {
            "targetUrl": "https://app.checkout.vsd.app.br",
            "targetVersion": "beta"
          }
        },
        {
          "id": "3b937b11-9f7d-4e13-ad89-1c14ff8add8d",
          "name": "VS OS Interface",
          "version": "2.4.0-1",
          "category": "module",
          "url": "https://repo.vsd.app.br/os-interface",
          "isPrimaryApp": false,
          "status": "active",
          "settings": {},
          "updateType": "apt",
          "strategy": {
            "type": "batch",
            "batchSize": 100,
            "maxConcurrentDownloads": 2
          },
          "retryPolicy": {
            "maxAttempts": 3,
            "backoffSeconds": 300
          },
          "plan": {
            "packages": [
              {
                "name": "vs-os-interface",
                "version": "2.4.0-1"
              }
            ],
            "commands": [
              "apt-get update",
              "apt-get install -y vs-os-interface=2.4.0-1"
            ]
          }
        },
        {
          "id": "9a317373-2f6f-45c7-a27f-053f8ddfce71",
          "name": "VS OS Base Update",
          "version": "2026.03.10",
          "category": "os",
          "url": "https://update-wowos.vsd.app.br/os/vs-os-2026.03.10.raucb",
          "isPrimaryApp": false,
          "status": "active",
          "settings": {},
          "updateType": "rauc",
          "strategy": {
            "type": "canary",
            "percentage": 5
          },
          "retryPolicy": {
            "maxAttempts": 2,
            "backoffSeconds": 600
          },
          "plan": {
            "bundleUrl": "https://update-wowos.vsd.app.br/os/vs-os-2026.03.10.raucb",
            "sha256": "c2a4a2f11f2e0e1944516ad8f3893f3556f04f85cc6a39f57f0a476814fbead1",
            "downloadPath": "/tmp/vs-os-2026.03.10.raucb",
            "installCommand": "rauc install /tmp/vs-os-2026.03.10.raucb",
            "rebootRequired": true
          }
        },
        {
          "id": "64f6b196-c1d8-4919-8d49-fbd68e3f88b4",
          "name": "VS AutoPag",
          "version": "2.1.0",
          "category": "module",
          "url": "https://registry.vsd.app.br/vs-autopag:2.1.0",
          "isPrimaryApp": false,
          "status": "active",
          "settings": {},
          "updateType": "docker",
          "strategy": {
            "type": "batch",
            "batchSize": 50,
            "maxConcurrentDownloads": 2
          },
          "retryPolicy": {
            "maxAttempts": 3,
            "backoffSeconds": 300
          },
          "plan": {
            "image": "registry.vsd.app.br/vs-autopag:2.1.0",
            "digest": "sha256:8b06accbcd03fce0f8f0f5b95fef83f0f4d678241eb6e3277ff56c96f40f7b8d",
            "containerName": "vs-autopag",
            "pullPolicy": "always",
            "restartPolicy": "graceful"
          }
        },
        {
          "id": "2994c52f-f7d4-47d8-be97-9bc0d4d523e2",
          "name": "VS Custom Installer",
          "version": "1.4.2",
          "category": "module",
          "url": "https://repo.vsd.app.br/installers/custom-installer-1.4.2.zip",
          "isPrimaryApp": false,
          "status": "active",
          "settings": {},
          "updateType": "zip-script",
          "strategy": {
            "type": "batch",
            "batchSize": 50,
            "maxConcurrentDownloads": 1
          },
          "retryPolicy": {
            "maxAttempts": 3,
            "backoffSeconds": 300
          },
          "plan": {
            "zipUrl": "https://repo.vsd.app.br/installers/custom-installer-1.4.2.zip",
            "sha256": "d2c7a9aa42636fa867f7efac568f6bde33b94bd9f5ad788fc66d72a27f3f9af1",
            "extractTo": "/opt/vsd/custom-installer",
            "script": {
              "path": "install.sh",
              "args": ["--env=prod"],
              "runAs": "root",
              "timeoutSeconds": 900
            }
          }
        }
      ]
    },
    "software": [
      {
        "id": "01KKPBGH02VB3KJ6T4GH7VPAXK",
        "name": "VS Senhas",
        "version": "production",
        "category": "module",
        "url": "https://api.senhas.vsd.app/v1",
        "isPrimaryApp": true,
        "status": "active",
        "principalEntity": "85.499.746/0001-44",
        "settings": {
          "general": {
            "language": "pt-BR",
            "timezone": "America/Sao_Paulo"
          },
          "queue": {
            "attendenceQueueOrder": "balancedQueue"
          },
          "attendance": {
            "nextTicketTimerDurationMs": 3000,
            "maxCallAttempts": 3,
            "reconnectDelayMs": 3000
          }
        }
      },
      {
        "id": "01KKPBGH02VB3KJ6T4GH7VPAXJ",
        "name": "VS Agenda",
        "version": "production",
        "category": "module",
        "url": "https://api.agenda.vsd.app/v1",
        "isPrimaryApp": true,
        "status": "active",
        "principalEntity": "85.499.746/0001-44",
        "settings": {
          "general": {
            "language": "en-US",
            "timezone": "America/Sao_Paulo"
          },
          "queue": {
            "attendenceQueueOrder": "balancedQueue"
          },
          "attendance": {
            "nextTicketTimerDurationMs": 3000,
            "maxCallAttempts": 3,
            "reconnectDelayMs": 3000
          }
        }
      },
      {
        "id": "f9a6fbb7-2b62-4c8a-b35c-45ddf85e48e3",
        "name": "VS Self Checkout App",
        "version": "production",
        "category": "pwa",
        "url": "https://app.checkout.vsd.app.br",
        "isPrimaryApp": true,
        "status": "active",
        "settings": {
          "general": {
            "language": ["pt-br", "en"],
            "currency": "R$",
            "cacheEnabled": true,
            "cacheDuration": 3600
          },
          "security": {
            "adminPasswordRequired": true,
            "passwordPolicy": {
              "minLength": 8,
              "requireNumbers": true,
              "requireSpecialChars": true
            },
            "qrcodeLoginEnabled": true
          },
          "integration": [
            {
              "erp": "Trier",
              "apiUrl": "https://api.trier.com/v1",
              "apiKey": "abc123xyz",
              "timeout": 30,
              "retryAttempts": 3,
              "syncInterval": 60
            }
          ],
          "logging": {
            "level": "info",
            "remoteLogging": true,
            "remoteLoggingUrl": "https://logs.vsd.app.br",
            "vsReport": true
          },
          "feature": {
            "loyalty": true,
            "coupons": false,
            "paymentMethod": ["credit_card", "debit_card", "pix"]
          },
          "payment": {
            "paymentOptions": [
              {
                "id": "credit",
                "label": "Crédito"
              },
              {
                "id": "debit",
                "label": "Débito"
              },
              {
                "id": "pix",
                "label": "PIX"
              }
            ]
          },
          "branding": {
            "themeColor": "#FF0000",
            "logoUrl": "https://example.com/logo.png"
          }
        }
      },
      {
        "id": "64f6b196-c1d8-4919-8d49-fbd68e3f88b4",
        "name": "VS AutoPay",
        "version": "2.0",
        "category": "module",
        "url": "https://repo.vsd.app.br/autopag",
        "isPrimaryApp": false,
        "status": "active",
        "settings": {}
      },
      {
        "id": "3b937b11-9f7d-4e13-ad89-1c14ff8add8d",
        "name": "VS OS Interface",
        "version": "2.3",
        "category": "module",
        "url": "https://repo.vsd.app.br/os-interface",
        "isPrimaryApp": false,
        "status": "active",
        "settings": {}
      },
      {
        "id": "3b937b11-9f7d-4e13-ad89-1c14ff8adwd8d",
        "name": "VS Mídias",
        "version": "2.3",
        "category": "library",
        "url": "https://repo.vsd.app.br/vs-media/2.3/media-lib",
        "isPrimaryApp": false,
        "status": "active",
        "settings": {}
      }
    ]
  }
}
